<template>
	<header ref="navRef" class="header">
		<div class="header__container">
			<GlobalHeaderNav />
			<div class="header__buttons-container">
				<ButtonPrimary class="header__call-btn" :href="'tel:+48794500550'" rel="nofollow">
					<span
						><span class="header__call-btn__hotline">{{ $t('components.header.infoline') }}</span> 24/7</span
					>
					<div class="header__call-btn-icon">
						<GlobalIcon name="call" :height="isMobile_lg ? 14 : 18" :width="isMobile_lg ? 14 : 18" />
					</div>
					<span class="header__call-btn__phone">+48 794 500 550</span>
				</ButtonPrimary>
				<GlobalLanguageSelect v-if="!isTablet_lg" class="header__lang-select" />
				<CurrencySelect v-if="!isTablet_lg" class="header__currency-select" />
				<button class="header__menu-btn" :class="{ 'header__menu-btn--opened': isMobileMenuOpen }" @click="openMenu">
					<GlobalIcon name="menu" :height="28" class="header__menu-open-icon" />
					<GlobalIcon name="close" :height="28" class="header__menu-close-icon" />
				</button>
			</div>
		</div>
	</header>

	<GlobalMegaMenuMobile v-if="isTablet_lg" />

	<GlobalHeaderStickyBooker v-if="props.booker" />
</template>

<script setup lang="ts">
const isMobileMenuOpen = ref(false)
const { isMobile_lg, isTablet_lg } = useWindowWidth()

provide('isMobileMenuOpen', isMobileMenuOpen)

const props = defineProps<{
	booker?: boolean
	bookerShowSelector?: string
}>()

const openMenu = () => {
	isMobileMenuOpen.value = !isMobileMenuOpen.value
}

watch(
	() => isMobileMenuOpen.value,
	(newValue) => {
		if (newValue) document.body.style.overflow = 'hidden'
		else document.body.style.overflow = 'auto'
	},
)
</script>

<style scoped lang="scss">
@import './Header';
</style>
